// extracted by mini-css-extract-plugin
module.exports = {"background":"background__2Pqat","container":"container__3kcQh","messageContainer":"messageContainer__14YOX","miniPlayerActive":"miniPlayerActive__36f8B"};